import { FilterItem } from 'components/multi-filter/multi-filter';
import { TableColumnProps } from 'components/table/table-component/table-component';

export const tableStructureCloudAccessList: TableColumnProps[] = [
  {
    id: 'role',
    title: 'Role',
    position: 'left',
    // withSort: true,
    // withSearch: true,
    // noFilters: true,
  },
  {
    id: 'policy',
    title: 'Policy',
    position: 'left',
    // withSort: true,
    // withSearch: true,
    // noFilters: true,
  },
  {
    id: 'user',
    title: 'User',
    position: 'left',
    // withSort: true,
    // noFilters: true,
  },
  {
    id: 'last_activity',
    title: 'Last Activity',
    position: 'left',
    isDate: true,
    withSort: true,
    // withSearch: true,
    noFilters: true,
  },
];

export const servicesTableStructure: TableColumnProps[] = [
  {
    id: 'service',
    title: 'Service',
    position: 'left',
  },
  {
    id: 'last_activity',
    title: 'Last Activity',
    position: 'left',
  },
];

export const AssetContributorsFilterList: FilterItem[] = [
  {
    title: 'Is owner',
    filterId: 'only_owners',
    filterColumns: ['user_id'],
    props: [
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ],
  },
  {
    title: 'Is overprivilege',
    filterId: 'only_overprivilege',
    filterColumns: ['user_id'],
    props: [
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ],
  },
];
